export default __webpack_public_path__ + "static/media/inrlogo2.a6a17f45.svg";